export default "__VITE_ASSET__D5t3geyP__"